import React from 'react';
import { useQueryClient, useMutation } from '@tanstack/react-query';

import { FeedbackContext, LocalizationContext } from '@cvt/contexts';

import { cacheKeys } from '../config';
import { companyClient } from '../client/companyClient';


export const useCompanyCrud = () => {

  const { dictionary } = React.useContext(LocalizationContext);
  const { triggerFeedback, genericErrorFeedback } = React.useContext(FeedbackContext);
  const queryClient = useQueryClient();

  const createCompany = useMutation({
    mutationFn: (data: Companies.Create) => companyClient.createCompany(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getCompanies],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const editCompany = useMutation({
    mutationFn: (data: Companies.Edit) => companyClient.editCompany(data),
    mutationKey: [cacheKeys.editCompany],
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getCompanies],
      });
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getCompany, {
          id: data.data.id,
        }],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  const deleteCompany = useMutation({
    mutationKey: [cacheKeys.deleteCompany],
    mutationFn: (id: number) => companyClient.deleteCompany({ id }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: [cacheKeys.getCompanies],
      });
      queryClient.removeQueries({
        queryKey: [cacheKeys.getCompany, {
          id: data.data.id,
        }],
      });
      triggerFeedback({
        severity: 'success',
        message: dictionary.feedback.changesSaved,
      });
    },
    onError: () => {
      genericErrorFeedback();
    },
  });

  return {
    createCompany: createCompany.mutateAsync,
    editCompany: editCompany.mutateAsync,
    deleteCompany: deleteCompany.mutateAsync,
  };
};
